export function TheGradient() {
  return (
    <div className='absolute inset-0 bg-[linear-gradient(180deg,transparent_0%,rgb(191,210,239)_100%)]' />
  )
}
